import { render, staticRenderFns } from "./SwiperDate.vue?vue&type=template&id=022879d6"
import script from "./SwiperDate.vue?vue&type=script&lang=js"
export * from "./SwiperDate.vue?vue&type=script&lang=js"
import style0 from "./SwiperDate.vue?vue&type=style&index=0&id=022879d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports